const getNumberOfReviews = (numberOfReviews) => {
  if (numberOfReviews > 0) {
    return `${numberOfReviews} Review${numberOfReviews > 1 ? 's' : ''}`;
  }
  return null;
};

export default getNumberOfReviews;
